import type { OnboardingEmailTemplate } from '../OnboardingEmailModal.types';

// Default 409A onboarding set and the fallback for valuation types without a
// dedicated template. Checklist labels (short) vs email/portal names (full)
// follow the Figma draft.
export const ONBOARDING_409A_TEMPLATE: OnboardingEmailTemplate = {
  id: '409a-onboarding',
  label: '409A Onboarding Default (10 Documents / 2 Questions)',
  emailSubject: 'Document request for your 409A valuation',
  introduction: `Hello {{CONTACT_FIRST_NAME}},

Thank you for partnering with us. We have completed an initial review of your file and are ready to move forward with your business valuation.

To help us build an accurate model and keep things moving efficiently, please provide the items listed below. Where available, Excel versions are strongly preferred to ensure precision in our analysis.`,
  documents: [
    {
      label: 'Financials - Year end, last 3 years',
      name: 'Financials - Historical annual income statements and year-end balance sheets',
      description: 'for the past three fiscal years if available',
    },
    {
      label: 'Financials - LTM Income Statement & Balance Sheet',
      name: 'Financials - Last twelve months income statement and balance sheet',
      description: 'as of the valuation date',
    },
    {
      label: 'Financials - NTM Projections',
      name: 'Financials - Next year financial projections',
    },
    {
      label: 'Financials - Projections, next 3 years',
      name: 'Financials - Next 3 - 5 year financial projections',
      description: 'if available',
    },
    {
      label: 'Cap table - including outstanding options/warrants with their respective strike prices',
      name: 'Cap table - Cap table',
      description:
        'as of the valuation date; including outstanding options/warrants with their respective strike prices',
    },
    {
      label: 'Cap table - Amended and Restated Certificate of Organization',
      name: 'Cap table - Amended and Restated Certificate of Incorporation or Operating Agreement',
      description:
        'or other document detailing the economic rights & preferences of various classes of equity',
    },
    {
      label: 'Cap table - Convertible Note ledger',
      name: 'Cap table - Convertible note/SAFE ledger and convertible note/SAFE agreement(s)',
      description: 'if applicable',
    },
    {
      label: 'Latest company pitch deck',
      name: 'Other - Latest Company pitch deck',
      description: 'if available',
    },
    {
      label: 'List of competitors',
      name: 'Other - A list of competitors and comparable firms',
      description: 'if available',
    },
    {
      label: 'Previous Valuation Opinions',
      name: 'Other - Any previous valuation opinions',
      description: 'if available',
    },
    {
      label: 'Question - Secondary transactions?',
      name: 'Question - Secondary transactions',
      description: 'has the company had any secondary transactions?',
      kind: 'question',
    },
    {
      label: 'Question - Term sheets?',
      name: 'Question - Term sheets',
      description:
        'has the company received any term sheets or does it have any potential debt/equity transactions in process?',
      kind: 'question',
    },
  ],
};
